import { allTrackers } from "app/services/track/track";
import Sentry from "@similarweb/sentry-logger";
import { openHooksModalV4 } from "app/services/ModalService";
import { trackEvent as appcuesTrackEvent } from "app/services/AppcuesService";

export const getPDFCallback =
    (
        isLoadingUpdater: (value: boolean) => void,
        pdfDownloadsMethod?: () => Promise<void>,
        isDownloadPdfHook?: boolean,
    ): (() => Promise<void>) =>
    async (): Promise<void> => {
        appcuesTrackEvent("PDF Button Click");

        if (isDownloadPdfHook) {
            await openHooksModalV4("DownloadPdf");
        } else {
            isLoadingUpdater(true);
            allTrackers.dispatchTrackEvent("Download", "submit-ok", "pdf");
            try {
                await pdfDownloadsMethod?.();
            } catch (e) {
                Sentry.error("Error downloading pdf", e as Error);
            } finally {
                isLoadingUpdater(false);
            }
        }
    };
